const OVERLAY_ID = 'debugFontOverlay';

const hasOwnText = (element: Element) =>
  Array.from(element.childNodes).some(
    (node) =>
      node.nodeType === Node.TEXT_NODE && node.textContent?.trim() !== '',
  );

export const showDebugFontOverlay = () => {
  if (document.getElementById(OVERLAY_ID)) {
    return;
  }

  const overlay = document.createElement('div');
  overlay.id = OVERLAY_ID;
  overlay.style.cssText =
    'position:absolute;top:0;left:0;width:0;height:0;z-index:2147483647;pointer-events:none;';

  document.body.querySelectorAll('*').forEach((element) => {
    if (!hasOwnText(element)) {
      return;
    }
    const rect = element.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) {
      return;
    }
    const { fontSize, lineHeight, fontWeight } = getComputedStyle(element);

    const label = document.createElement('span');
    label.textContent = `${fontSize} / ${lineHeight}\n${fontWeight}`;
    label.style.cssText = [
      'position:absolute',
      `top:${rect.top + window.scrollY}px`,
      `left:${rect.left + window.scrollX}px`,
      'padding:1px 3px',
      'background:rgba(255,0,0,0.85)',
      'color:#fff',
      'font:10px/10px monospace',
      'white-space:pre',
    ].join(';');
    overlay.appendChild(label);
  });

  document.body.appendChild(overlay);
};

export const hideDebugFontOverlay = () => {
  document.getElementById(OVERLAY_ID)?.remove();
};
